import EmailVerificationStatusPopup from './EmailVerificationStatusPopup';

export default EmailVerificationStatusPopup;
